module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-testimonials"
  }, [_c('div', {
    staticClass: "slider-testimonials__quote-top"
  }, [_c('Icon', {
    attrs: {
      "name": "Quotes"
    }
  })], 1), _c('div', {
    staticClass: "slider-testimonials__quote-bottom"
  }, [_c('Icon', {
    attrs: {
      "name": "Quotes"
    }
  })], 1), _c('swiper', {
    staticClass: "slider-testimonials__slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.props), function(slide, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "slider-testimonials__slide"
    }, [_c('div', {
      staticClass: "slider-testimonials__testimonial",
      domProps: {
        "innerHTML": _vm._s(slide.testimonial)
      }
    }), _c('div', {
      staticClass: "slider-testimonials__author"
    }, [_vm._v("- " + _vm._s(slide.author))])])
  })), _c('div', {
    staticClass: "slider-testimonials__prev-arrow"
  }, [_c('Icon', {
    attrs: {
      "name": "LeftCarot"
    }
  })], 1), _c('div', {
    staticClass: "slider-testimonials__next-arrow"
  }, [_c('Icon', {
    attrs: {
      "name": "RightCarot"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f507da5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-testimonials/slider-testimonials.pug
// module id = 639
// module chunks = 1